import React, { useEffect, useState } from "react";
import axios from "../api";

export default function AdminBadges() {
  const [badges, setBadges] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", description: "", icon: "", category: "", condition: "", sortIndex: 100 });
  const [levelForm, setLevelForm] = useState([]);

  useEffect(() => {
    axios.get("/badges").then(res => setBadges(res.data));
  }, []);

  function handleEdit(badge) {
    setEditing(badge.id);
    setForm({
      ...badge,
      condition: JSON.stringify(badge.condition || ""),
      sortIndex: badge.sortIndex ?? 100
    });
    setLevelForm(
      Array.isArray(badge.BadgeLevels)
        ? badge.BadgeLevels.map(l => ({ ...l, condition: JSON.stringify(l.condition || "") }))
        : []
    );
  }

  function handleNewBadge() {
    setEditing(null);
    setForm({ name: "", description: "", icon: "", category: "", condition: "", sortIndex: 100 });
    setLevelForm([{ name: '', description: '', icon: '', level: 1, condition: '' }]);
  }

  function handleDelete(id) {
    if (window.confirm("Abzeichen wirklich löschen?")) {
      axios.delete(`/badges/${id}`).then(() => {
        setBadges(badges => badges.filter(b => b.id !== id));
        setEditing(null);
      });
    }
  }

  function handleLevelChange(idx, field, value) {
    setLevelForm(levels => levels.map((l, i) => i === idx ? { ...l, [field]: value } : l));
  }

  function handleAddLevel() {
    setLevelForm(levels => [...levels, { name: '', description: '', icon: '', level: levels.length+1, condition: '' }]);
  }

  function handleDeleteLevel(idx) {
    setLevelForm(levels => levels.filter((_, i) => i !== idx));
  }

  async function handleSave(e) {
    e.preventDefault();
    const payload = { ...form, condition: form.condition ? JSON.parse(form.condition) : null };
    let badgeRes;
    if (editing) {
      badgeRes = await axios.put(`/badges/${editing}`, payload);
    } else {
      badgeRes = await axios.post("/badges", payload);
    }
    const badgeId = badgeRes.data.id;
    // Levels speichern
    await Promise.all(levelForm.map(async (level) => {
      const levelPayload = { ...level, condition: level.condition ? JSON.parse(level.condition) : null, badgeId };
      if (level.id) {
        await axios.put(`/badge-levels/${level.id}`, levelPayload);
      } else {
        await axios.post(`/badge-levels`, levelPayload);
      }
    }));
    // Lösche entfernte Levels (optional, falls Backend das unterstützt)
    // ...
    // Abzeichen neu laden
    axios.get("/badges").then(res => setBadges(res.data));
    setEditing(null);
    setForm({ name: "", description: "", icon: "", category: "", condition: "" });
    setLevelForm([]);
  }

  return (
    <div style={{ width: '100vw', margin: 0, padding: '40px 0', background: 'transparent' }}>
      <div style={{ maxWidth: 700, margin: "0 auto", background: "#222", borderRadius: 16, boxShadow: "0 2px 16px #0002", padding: 24, position:'relative', left:'-120px' }}>
        <h2>Abzeichenverwaltung</h2>
        <form onSubmit={handleSave} style={{ marginBottom: 24 }}>
          <input placeholder="Name" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
          <input placeholder="Beschreibung" value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} required />
          <input placeholder="Icon (Pfad/URL)" value={form.icon} onChange={e => setForm(f => ({ ...f, icon: e.target.value }))} required />
          <input placeholder="Kategorie" value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))} />
          <input placeholder="Bedingung (JSON)" value={form.condition} onChange={e => setForm(f => ({ ...f, condition: e.target.value }))} />
          <input placeholder="Sortier-Index" type="number" value={form.sortIndex} onChange={e => setForm(f => ({ ...f, sortIndex: Number(e.target.value) }))} style={{width:120}} />
          <h4 style={{marginTop:18}}>Stufen (Levels)</h4>
          {levelForm.map((level, idx) => (
            <div key={idx} style={{background:'#333',borderRadius:8,padding:10,marginBottom:8,display:'flex',gap:10,alignItems:'center'}}>
              <input placeholder="Name" value={level.name} onChange={e => handleLevelChange(idx, 'name', e.target.value)} style={{width:90}} />
              <input placeholder="Beschreibung" value={level.description} onChange={e => handleLevelChange(idx, 'description', e.target.value)} style={{width:140}} />
              <input placeholder="Icon (Pfad/URL)" value={level.icon} onChange={e => handleLevelChange(idx, 'icon', e.target.value)} style={{width:120}} />
              <input placeholder="Level" type="number" min={1} value={level.level} onChange={e => handleLevelChange(idx, 'level', e.target.value)} style={{width:60}} />
              <input placeholder="Bedingung (JSON)" value={level.condition} onChange={e => handleLevelChange(idx, 'condition', e.target.value)} style={{width:120}} />
              <button type="button" onClick={() => handleDeleteLevel(idx)} style={{background:'#c00',color:'#fff'}}>Entfernen</button>
            </div>
          ))}
          <button type="button" onClick={handleAddLevel} style={{marginBottom:12}}>Stufe hinzufügen</button>
          <button type="submit">{editing ? "Speichern" : "Neu anlegen"}</button>
          {editing && <button type="button" onClick={() => { setEditing(null); setForm({ name: "", description: "", icon: "", category: "", condition: "" }); setLevelForm([]); }}>Abbrechen</button>}
        </form>
        <button type="button" onClick={handleNewBadge} style={{marginBottom:12}}>Neues Abzeichen anlegen</button>
        <table style={{ width: "100%", background: "#222", color: "#eee", borderCollapse: "collapse", position:'relative', left:'-60px' }}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Beschreibung</th>
              <th>Kategorie</th>
              <th>Sortier-Index</th>
              <th>Stufen & Bedingungen</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {badges.map(badge => (
              <tr key={badge.id} style={{ borderBottom: "1px solid #444" }}>
                <td>{badge.name}</td>
                <td>{badge.description}</td>
                <td>{badge.category}</td>
                <td>{badge.sortIndex ?? 100}</td>
                <td>
                  {Array.isArray(badge.BadgeLevels) && badge.BadgeLevels.length > 0 ? (
                    <ul style={{paddingLeft:16,margin:0}}>
                      {badge.BadgeLevels.sort((a,b)=>a.level-b.level).map(level => (
                        <li key={level.id} style={{marginBottom:8,display:'flex',alignItems:'center',gap:10}}>
                          <img src={level.icon} alt={level.name} style={{width:32,height:32,borderRadius:8,background:'#333'}} />
                          <div>
                            <b>{level.name}</b> (Level {level.level}): {level.description}<br/>
                            <span style={{fontSize:12,color:'#aaa'}}>Bedingung: {JSON.stringify(level.condition)}</span>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span style={{color:'#888'}}>Keine Stufen</span>
                  )}
                </td>
                <td>
                  <button onClick={() => handleEdit(badge)}>Bearbeiten</button>
                  <button onClick={() => handleDelete(badge.id)}>Löschen</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
